import { type ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { Avatar, LoadingIndicator } from '@ics-portal/guardian';
import { GET_PARTICIPANTS_FOR_PROJECT } from '@api/queries/projects';
import { useMapContext } from '@pages/map/_utils/map-context';
import s from '../project-details-box.module.scss';

export function ProjectDetailsMembers(): ReactNode {
    const { project } = useMapContext();

    const { data, loading } = useQuery(GET_PARTICIPANTS_FOR_PROJECT, {
        skip: !project,
        variables: {
            pid: project?.id ?? '',
        },
    });

    if (!project) {
        return null;
    }

    if (loading) {
        return <LoadingIndicator variant="ripple" />;
    }

    const participants = data?.projects?.edges[0]?.node.participants;

    if (!participants) {
        return null;
    }
    const longList = participants.length > 6;
    const first = longList ? participants.slice(0, 6) : participants;
    const rest = longList ? participants.length - 6 : 0;

    return (
        <div className="flex flex-row justify-content-between align-items-center">
            <div>Members</div>
            <div className="flex flex-row align-items-center">
                {first.map((participant) => (
                    <div key={participant?.id} className={s.avatarWrapper}>
                        <Avatar
                            userName={`${participant?.user.firstName} ${participant?.user.lastName}`}
                        />
                    </div>
                ))}
                {rest > 0 && <Avatar userName={`+ ${rest}`} />}
            </div>
        </div>
    );
}
